import { Component, HostBinding, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Icon } from '../icon/icon';
import { CSSValuePipe } from '@pipes/css-value-pipe';
import type { IconName, CssColor, FontWeight } from '@appTypes';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [MatTooltip, CSSValuePipe, Icon],
  templateUrl: './button.html',
  styleUrl: './button.scss',
})
export class Button {
  // Inputs
  $text = input<string | null>(null, { alias: 'text' });
  $textFontSize = input<string>('--font-size-medium', { alias: 'textFontSize' });
  $textTop = input<string>(undefined, { alias: 'textTop' });
  $textRight = input<string>(undefined, { alias: 'textRight' });
  $textBottom = input<string>(undefined, { alias: 'textBottom' });
  $textLeft = input<string>(undefined, { alias: 'textLeft' });
  $textWeight = input<FontWeight>('normal', { alias: 'textWeight' });
  $textColor = input<CssColor>('--black-white', { alias: 'textColor' });
  $textWrap = input<boolean>(false, { alias: 'textWrap' });
  $hostWidth = input<string>('fit-content', { alias: 'hostWidth' });
  $innerPadding = input<string | undefined>(undefined, { alias: 'innerPadding' });
  $activeIndicator = input<boolean>(false, { alias: 'activeIndicator' });
  $activeIndicatorColor = input<CssColor>('--secondary', { alias: 'activeIndicatorColor' });
  $gap = input<string>('--gap-small', { alias: 'gap' });
  $icon = input<IconName | null>(null, { alias: 'icon' });
  $iconColor = input<'original' | CssColor>('--secondary', { alias: 'iconColor' });
  $iconSize = input<string>('', { alias: 'iconSize' });
  $iconScale = input<number>(1, { alias: 'iconScale' });
  $iconRotation = input<number>(0, { alias: 'iconRotation' });
  $iconRotationDelay = input<number>(0, { alias: 'iconRotationDelay' });
  $iconViewBoxAdjustmentX = input<number>(0, { alias: 'iconViewBoxAdjustmentX' });
  $iconViewBoxAdjustmentY = input<number>(0, { alias: 'iconViewBoxAdjustmentY' });
  $iconPosition = input<'top' | 'right' | 'bottom' | 'left'>('right', { alias: 'iconPosition' });
  $verticalAlignment = input<'start' | 'center' | 'end'>('start', { alias: 'verticalAlignment' });
  $disabled = input<boolean>(false, { alias: 'disabled' });
  $tooltip = input<string>('', { alias: 'tooltip' });
  $tooltipWhenDisabled = input<string>('', { alias: 'tooltipWhenDisabled' });

  // Bindings
  @HostBinding('style.width')
  get hostWidth(): string { return this.$hostWidth(); }
}
